import { useEffect, useState } from "react";
import { ExternalLink, BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import ClaimNftDialog, { SolMark } from "@/components/ClaimNftDialog";

function Owned({ l, enabled, onClaim }) {
  const n = l.nft;
  const done = n?.status === "complete";
  return (
    <div className="rounded-2xl overflow-hidden border border-amber-400/40 bg-[#081820]/80" data-testid={`my-look-${l.id}`}>
      <img src={`${process.env.REACT_APP_BACKEND_URL}${l.image}`} alt={l.name} loading="lazy" className="w-full aspect-square object-cover" />
      <div className="p-3 space-y-2">
        <p className="text-sm text-white font-semibold truncate">#{l.no} · {l.name}</p>
        {done ? (
          <>
            <p className="text-[11px] text-emerald-300 flex items-center gap-1" data-testid={`my-look-claimed-${l.id}`}><BadgeCheck className="w-3.5 h-3.5" />Claimed as NFT</p>
            <a href={n.explorer} target="_blank" rel="noreferrer" data-testid={`my-look-view-${l.id}`} className="text-[11px] text-cyan-300 hover:underline inline-flex items-center gap-1">View NFT <ExternalLink className="w-3 h-3" /></a>
          </>
        ) : n?.status === "minting" ? <p className="text-[11px] text-amber-200" data-testid={`my-look-minting-${l.id}`}>Minting…</p> : (
          <>
            <button data-testid={`claim-nft-${l.id}`} disabled={!enabled} onClick={() => onClaim(l)}
              className="w-full py-2 rounded-full bg-gradient-to-r from-amber-300 to-yellow-500 text-black text-xs font-bold inline-flex items-center justify-center gap-1.5 hover:brightness-110 transition-[filter] disabled:opacity-40">
              <SolMark /> CLAIM AS NFT
            </button>
            {!enabled && <p className="text-[10px] text-slate-500 text-center">NFT claiming opens soon</p>}
            {n?.status === "failed" && <p className="text-[10px] text-red-300 text-center" data-testid={`my-look-failed-${l.id}`}>{n.error || "Last try didn't finish."} You can safely try again.</p>}
          </>
        )}
      </div>
    </div>
  );
}

export default function MyUniqueLooks({ title = "My 1/1 wolves" }) {
  const [d, setD] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [claiming, setClaiming] = useState(null);
  const load = () => api.get("/looks/unique/mine").then(({ data }) => {
    setD({ looks: data.looks.filter((l) => l.nft?.status !== "complete") });
    window.dispatchEvent(new Event("unique-looks-changed"));
  }).catch(() => {});
  useEffect(() => { load(); api.get("/sol/status").then(({ data }) => setEnabled(data.enabled)).catch(() => {}); }, []);
  if (!d?.looks.length) return null;
  return (
    <section className="glass rounded-2xl p-6" data-testid="my-unique-looks">
      <h3 className="font-display text-xl text-amber-100 mb-1">{title}</h3>
      <p className="text-xs text-slate-400 mb-4">Each one can be claimed once as a Solana NFT (a small SOL cost paid from your wallet) you can trade on Magic Eden or Tensor.</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">{d.looks.map((l) => <Owned key={l.id} l={l} enabled={enabled} onClaim={setClaiming} />)}</div>
      {claiming && <ClaimNftDialog look={claiming} open onClose={() => { setClaiming(null); load(); }} onClaimed={load} />}
    </section>
  );
}
